import { useContext } from 'react';

import { CacheScopeContext, type CacheScope } from '@/contexts/cache-scope-context';

export type { CacheScope } from '@/contexts/cache-scope-context';

/**
 * The actor and organisation to scope a viewer-specific cache entry by. Reads
 * `CacheScopeContext` (see there for why it is its own context); outside
 * `CacheScopeProvider` both fields are `null`.
 */
export function useCacheScope(): CacheScope {
  return useContext(CacheScopeContext);
}
